import {
  TOGGLE_RISK_SUCCESS,
  TOGGLE_RISK_FAILURE,
  TOGGLE_RISK_REQUEST,
  UPDATE_RISK_REQUEST,
  UPDATE_RISK_SUCCESS,
  UPDATE_RISK_FAILURE,
  CREATE_RISK_REQUEST,
  CREATE_RISK_SUCCESS,
  CREATE_RISK_FAILURE,
  DELETE_RISK_REQUEST,
  DELETE_RISK_SUCCESS,
  DELETE_RISK_FAILURE,
  UPDATE_RISK_BY_LEVEL_REQUEST,
  UPDATE_RISK_BY_LEVEL_SUCCESS,
  UPDATE_RISK_BY_LEVEL_FAILURE,
  DELETE_RISK_BY_LEVEL_REQUEST,
  DELETE_RISK_BY_LEVEL_SUCCESS,
  DELETE_RISK_BY_LEVEL_FAILURE,
  CLEAR_RISK,
  UPDATE_RISK_TAGS
} from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultRiskState = {
  pending: false,
  id: null,
  result: false,
  hidden: null,
  updateSuccess: false,
  cellValue: '',
  row: {},
  risk: {},
  updateByLevelPending: false,
  updateByLevelSuccess: false,
  updateByLevelRisks: [],
  deleteByLevelPending: false,
  deleteByLevelSuccess: false,
  deleteByLevelRisks: [],
  updatedAccountableManagerRisks: null,
}

export default (state = defaultRiskState, action) => {

  var newState = {...state}

  switch (action.type){
    case TOGGLE_RISK_REQUEST:
      newState.pending = true;
      newState.id = null
      newState.hidden = null
      newState.result = false
      newState.updateSuccess = false;
      return newState;
    case TOGGLE_RISK_SUCCESS:
      newState.pending = false
      newState.id = action.id
      newState.hidden = action.hidden
      newState.result = action.result
      return newState;
    case TOGGLE_RISK_FAILURE:
      return defaultRiskState;
    case UPDATE_RISK_REQUEST:
      newState.pending = true;
      newState.updateSuccess = false;
      return newState;
    case UPDATE_RISK_SUCCESS:
      newState.cellValue = action.cellValue;
      newState.risk = action.body;
      newState.row = action.row;
      newState.pending = false;
      newState.updateSuccess = true;
      newState.result = true;
      return newState;
    case UPDATE_RISK_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false;
      return newState;
    case CREATE_RISK_REQUEST:
      newState.pending = true;
      newState.updateSuccess = false;
      return newState;
    case CREATE_RISK_SUCCESS:
      newState.pending = false;
      newState.updateSuccess = true;
      newState.risk = action.body;
      return newState;
    case CREATE_RISK_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false;
      return newState;
    case DELETE_RISK_REQUEST:
      newState.pending = true;
      newState.updateSuccess = false;
      return newState;
    case DELETE_RISK_SUCCESS:
      newState.pending = false;
      newState.updateSuccess = true;
      newState.risk = action.body;
      return newState;
    case DELETE_RISK_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false;
      return newState;
    case UPDATE_RISK_BY_LEVEL_REQUEST:
      newState.updateByLevelPending = true;
      newState.updateByLevelSuccess = false;
      return newState;
    case UPDATE_RISK_BY_LEVEL_SUCCESS:
      newState.updateByLevelPending = false;
      newState.updateByLevelSuccess = true;
      newState.updateByLevelRisks = action.body;
      return newState;
    case UPDATE_RISK_BY_LEVEL_FAILURE:
      newState.updateByLevelPending = false;
      newState.updateByLevelSuccess = false;
      newState.updatedAccountableManagerRisks = null;
      return newState;
    case DELETE_RISK_BY_LEVEL_REQUEST:
      newState.deleteByLevelPending = true;
      newState.deleteByLevelSuccess = false;
      return newState;
    case DELETE_RISK_BY_LEVEL_SUCCESS:
      newState.deleteByLevelPending = false;
      newState.deleteByLevelSuccess = true;
      newState.deleteByLevelRisks = action.body;
      return newState;
    case DELETE_RISK_BY_LEVEL_FAILURE:
      newState.deleteByLevelPending = false;
      newState.deleteByLevelSuccess = false;
      return newState;
    case UPDATE_RISK_TAGS.request:
    case UPDATE_RISK_TAGS.failure:
      newState.action_type = action.type
      return newState;
    case UPDATE_RISK_TAGS.success:
      newState.action_type = action.type
      newState.risk = action.data;
      return newState;
    case CLEAR_RISK:
      newState = defaultRiskState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/risk.js